module.exports = __webpack_public_path__ + "static/670b7f6bda142d4ea2a236c2439849d8bacd2bdc86f7359173d37c409e8f0fc7-607f32e998b0942dac931317532d4d71.jpeg";